// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3112":"192beb56","3544":"192beb56","3818":"e5138108","4441":"799a733a","6444":"192beb56","7289":"192beb56","8173":"192beb56","8987":"579d4fa2","9271":"192beb56"}[chunkId] + ".chunk.css";
};